import React from 'react';
import ReactDOM from 'react-dom';
import { store } from '../../../../store/store';
import { Provider } from 'react-redux';
import { loadDOMComponent } from '../../../../helpers';
import { AppContextProvider } from '../../../../Services/AppContext';
import AclContextProvider from '../../../Acl/Components/AclContextProvider';
import LaboratoryResult from './LaboratoryResult';

loadDOMComponent({
	selector: 'react-laboratory-result',
	callback: ({ container }: any) => {
		const laboratoryResultId = container.getAttribute(
			'data-laboratoryResultId',
		);

		ReactDOM.render(
			<Provider store={store}>
				<AppContextProvider>
					<AclContextProvider>
						<LaboratoryResult laboratoryResultId={laboratoryResultId} />
					</AclContextProvider>
				</AppContextProvider>
			</Provider>,
			container,
		);
	},
});
